/*eslint-disable*/
import React, { useState } from "react";
import Navbar from "../../Componenets/Navbar";
import phone from "../../Assests/Globalimages/phone.png";
import email from "../../Assests/Globalimages/email.png";
import location from "../../Assests/Globalimages/location.png";
import Footer from "../../Componenets/Footer";
import { useNavigate } from "react-router-dom";
import axios from "../../Axios/";
import toast, { Toaster } from 'react-hot-toast';

const ContactUs = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });
  const [errors, setErrors] = useState({
    name: "",
    email: "",
    message: ""
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error when user types
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ""
      }));
    }
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = { ...errors };

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
      valid = false;
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
      valid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Please enter a valid email";
      valid = false;
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) return;

    setIsSubmitting(true);
    
    try {
      const response = await axios.post('otp/sendContactUsEmail', {
        name: formData.name,
        email: formData.email,
        message: formData.message
      });

      if (response.status == 200) {
        toast.success("Message sent successfully!");
        setFormData({
          name: "",
          email: "",
          message: ""
        });
      } else {
        toast.error("Failed to send message. Please try again.");
      }
    } catch (error) {
      console.error("Error sending message:", error);
      toast.error("An error occurred. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <Navbar />
      <Toaster />
      <section className="hand-made-section">
        <div className="container">
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-lg-8">
              <div className="content-hand-made text-center">
                <h3 style={{marginTop:59}}>Get In Touch!</h3>
                <h1>Pure. Handmade. Nature's Best for Your Skin!</h1>
                <div className="button-hand-made mt-3">
                  <button
                    type="button"
                    className="btn-lg hand-made"
                    onClick={()=> navigate('/shop')}
                  >
                    Shop Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="map-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="content-map">
                <div className="-map">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2928.675775109314!2d-73.9684273!3d42.774061800000005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89de71a65794617b%3A0xc145a50f4a691566!2s212%20Shirlwood%20Dr%2C%20Rotterdam%2C%20NY%2012306%2C%20USA!5e0!3m2!1sen!2s!4v1744288700427!5m2!1sen!2s" width="600" height="450"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
                <div className="content-contact">
                  <h4>Contact Us</h4>
                  <div className="mobile">
                    <div className="phone d-flex align-items-center">
                      <img src={phone} className="img-fluid phone-pic" alt="Phone" />
                      <h5>Phone</h5>
                    </div>
                    <p>518-937-5177</p>
                  </div>
                  <div className="mobile">
                    <div className="phone d-flex align-items-center">
                      <img src={email} className="img-fluid email-pic" alt="Email" />
                      <h5>Email</h5>
                    </div>
                    <p>crystlsviola@gmail.com</p>
                  </div>
                  <div className="mobile">
                    <div className="phone d-flex align-items-center">
                      <img
                        src={location}
                        className="img-fluid location-pic"
                        alt="Location"
                      />
                      <h5>Address</h5>
                    </div>
                    <p>|212 Shirlwood Drive
                    Schenectady NY 12306</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="contact-form">
                <form onSubmit={handleSubmit}>
                  <div className="mb-3 form-bt">
                    <label htmlFor="name" className="form-label">
                      Name*
                    </label>
                    <input
                      type="text"
                      className={`form-control ${errors.name ? "is-invalid" : ""}`}
                      id="name"
                      name="name"
                      placeholder="Enter Name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                    {errors.name && (
                      <div className="invalid-feedback">{errors.name}</div>
                    )}
                  </div>
                  <div className="mb-3 form-bt">
                    <label htmlFor="email" className="form-label">
                      Email*
                    </label>
                    <input
                      type="email"
                      className={`form-control ${errors.email ? "is-invalid" : ""}`}
                      id="email"
                      name="email"
                      placeholder="abc@gmail.com"
                      value={formData.email}
                      onChange={handleChange}
                    />
                    {errors.email && (
                      <div className="invalid-feedback">{errors.email}</div>
                    )}
                  </div>
                  <div className="mb-3 form-bt">
                    <label htmlFor="message" className="form-label">
                      Message*
                    </label>
                    <textarea
                      className={`form-control ${errors.message ? "is-invalid" : ""}`}
                      id="message"
                      name="message"
                      rows="3"
                      placeholder="Your message"
                      value={formData.message}
                      onChange={handleChange}
                    ></textarea>
                    {errors.message && (
                      <div className="invalid-feedback">{errors.message}</div>
                    )}
                  </div>
                  <button 
                    type="submit" 
                    className="form-btn"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Sending..." : "Submit"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    
      <Footer />
    </div>
  );
};

export default ContactUs;